// extracted by mini-css-extract-plugin
module.exports = {"cell":"styles_cell__StFp_","skeleton":"styles_skeleton__di6I5","totalCell":"styles_totalCell__3qhR0","isTotal":"styles_isTotal__2PQeW"};